import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"

export default function TPGGames() {
  const data = promotionsData.find(
    (promo) => promo.title === "TPG Trick or Treat"
  )

  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> TPG Trick or Treat </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> TPG Trick or Treat </h1>
                <h2> Total 5,552 Free Spins (1,388 Free Spins each week) </h2>
                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span>November 1 - November 28, 2025 (GMT + 8)</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Terms & Conditions </strong>
                <ol>
                  <li>
                    Campaign duration: November 1, 2025 – November 28, 2025
                    (GMT+8).
                  </li>
                  <ul>
                    <li>
                      Week 1: 1 November 00:00:00 – 7 November 23:59:59 (GMT+8)
                    </li>
                    <li>
                      Week 2: 8 November 00:00:00 – 14 November 23:59:59 (GMT+8)
                    </li>
                    <li>
                      Week 3: 15 November 00:00:00 – 21 November 23:59:59
                      (GMT+8)
                    </li>
                    <li>
                      Week 4: 22 November 00:00:00 – 28 November 23:59:59
                      (GMT+8)
                    </li>
                  </ul>
                  <li>
                    The following games participate in the campaign
                    (“Participating games”): Halloween Hold & Spin
                    <MasterGamesList
                      pragmaticGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customPragmaticGames={[
                        {
                          provider: "tpg",
                          gameName: "Halloween Hold & Spin",
                        },
                      ]}
                      rank="off"
                      limit={2}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  </li>

                  <li>
                    Only real money rounds can participate in the tournament.
                  </li>
                  <li>
                    Participating players can join the campaign by placing a
                    qualifying bet on the designated game during the campaign
                    period. No additional cost is required.
                  </li>
                  <li>No minimum bet is required to participate.</li>
                  <li>
                    The top 10 players with the highest wagers each week in
                    “Halloween Hold & Spin” will be recognized as winners.
                  </li>
                  <li>
                    Each player’s total weekly accumulated gross bets will be
                    calculated and the leaderboard will be updated every week
                    between 12 PM and 2 PM (GMT+8).
                  </li>
                  <li>
                    In the event of a tie, players with the same wager amount
                    will be ranked according to who achieved the amount first.
                  </li>
                  <li>
                    Free Spins will be credited to the game accounts of the top
                    10 players (for a specific game) on the next business day
                    after each weekly campaign.
                  </li>
                  <li>
                    Free Spins awarded will expire within 30 days and are
                    non-transferable.
                  </li>
                  <li>Prizes are awarded after each week of the campaign.</li>
                  <li>
                    The awarded Free Spins can only be used on the specific TPG
                    slot game: Halloween Hold & Spin
                  </li>
                  <li>
                    Value of each Free Spin, rewarded for this campaign is ₱15
                    or equivalent in your currency
                  </li>
                  <li>
                    TPG reserves the right to the final interpretation of this
                    promotion.
                  </li>
                </ol>

                <div className="promotion-tnc-cta">
                  <a
                    href="https://tournament.triple-pg.com/tpg-trick-or-treat-weekly-challenge/"
                    className="promotion-cta-btn"
                    target="_blank"
                  >
                     Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
